<script setup>

import { ChevronRightIcon } from '@heroicons/vue/20/solid/index.js'
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue'
import TwTransitionContainer from '../generic/tw-transition-container.vue'
</script>

<template>
  <Disclosure v-slot="{ open }" as="div" class="mt-2">
    <DisclosureButton class="flex w-full justify-between rounded-lg bg-gray-100 px-4 py-2 text-left text-sm font-medium text-gray-900 hover:bg-gray-200 focus:outline-none focus-visible:ring focus-visible:ring-gray-500/75">
      <ChevronRightIcon :class="open ? 'rotate-90 transform' : ''" class="h-5 w-5 text-gray-500" />
      <slot />
      <slot name="right" />
    </DisclosureButton>
    <tw-transition-container>
      <DisclosurePanel class="px-4 pb-2 pt-4 text-sm text-gray-500">
        <slot name="expanded" />
      </DisclosurePanel>
    </tw-transition-container>
  </Disclosure>
</template>

<style scoped>

</style>
